<template>
  <div v-if="textarea" class="promotion-activity">
    <div class="promotion-activity_content">
      <div class="promotion-activity_content_title">
        <div class="promotion-activity_content_title_ctx">
          <h3 class="pc_owner_mod_header">活动内容</h3>
        </div>
      </div>
      <div class="promotion-activity_content_textarea">
        <p>{{ textarea }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.promotion-activity {
  background: white;
  margin-bottom: 20px;
  border: 1px solid rgba(239, 241, 242, 1);
  .promotion-activity_content {
    .promotion-activity_content_title {
      .promotion-activity_content_title_ctx {
        border-bottom: 1px solid rgba(239, 241, 242, 1);
        padding: 20px;
        font-size: 18px;
        font-weight: 500;
        color: rgba(68, 68, 68, 1);
        line-height: 18px;
      }
    }
    .promotion-activity_content_textarea {
      padding: 15px 14px 15px 21px;
      font-size: 14px;
      white-space: pre-wrap;
      font-weight: 400;
      color: rgba(68, 68, 68, 1);
      line-height: 24px;
      word-break: break-all;
    }
  }
}

@media screen and (max-width: 940px) {
  .promotion-activity {
    background: white;
    border: none;
    .promotion-activity_content {
      .promotion-activity_content_textarea {
        white-space: pre-wrap;
        padding: 15px;
        font-size: 15px;
        font-weight: 400;
        color: rgba(68, 68, 68, 1);
        line-height: 24px;
      }
      .promotion-activity_content_title {
        .promotion-activity_content_title_ctx {
          border-bottom: 0px;
          padding: 15px 15px 0px 15px;
          font-size: 16px;
          font-weight: 500;
          color: rgba(68, 68, 68, 1);
          line-height: 16px;
          .pc_owner_mod_header {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    textarea: {
      default: '',
      type: String
    }
  }
}
</script>
